const CBA_SPACER_BLOCK_TYPES = new Set(['paragraph', 'annotation']);
const MEANINGFUL_MEDIA_HTML = /<(?:img|table|svg|video|audio|iframe|canvas)\b/i;
const TRAILING_PARAGRAPH_BREAKS = /(?:\s*<br\s*\/?>\s*)+(?=(?:<!--[\s\S]*?-->\s*)*$)/gi;

function hasVisibleText(value: unknown): boolean {
  return String(value ?? '')
    .replace(/<[^>]*>/g, '')
    .replace(/&(?:nbsp|#160|#x0*a0);/gi, '')
    .replace(/[\s\u00a0\u200b-\u200d\ufeff]/g, '')
    .length > 0;
}

function isEmptyCbaSpacerBlock(block: any): boolean {
  if (!CBA_SPACER_BLOCK_TYPES.has(String(block?.type || '').toLowerCase())) {
    return false;
  }

  const html = String(block?.html || '');
  return !hasVisibleText(block?.text)
    && !hasVisibleText(html)
    && !MEANINGFUL_MEDIA_HTML.test(html);
}

function trimCbaParagraphSpacerBreaks(block: any): any {
  if (String(block?.type || '').toLowerCase() !== 'paragraph' || !block?.html) {
    return block;
  }

  return {
    ...block,
    html: String(block.html).replace(TRAILING_PARAGRAPH_BREAKS, ''),
  };
}

export function citationBlocksForModal(blocks: any[], sourceType: string): any[] {
  const copiedBlocks = (blocks || []).map((block: any) => ({ ...block }));
  if ((sourceType || '').toLowerCase() !== 'cba') {
    return copiedBlocks;
  }

  return copiedBlocks
    .filter((block: any) => !isEmptyCbaSpacerBlock(block))
    .map(trimCbaParagraphSpacerBreaks);
}
